// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Project Test Plan Styles */

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Form Container Animations */
.project-test-plan-form {
  animation: slideIn 0.3s ease-out;
}

/* Section Headers */
.project-test-plan-form h2 {
  position: relative;
  padding-bottom: 1rem;
}

/* Smooth transitions for form elements */
input[type="text"],
input[type="date"],
textarea,
select {
  transition: all 0.2s ease-in-out;
}

input[type="text"]:focus,
input[type="date"]:focus,
textarea:focus,
select:focus {
  transform: translateY(-1px);
}

/* Table Row Hover Effect */
tbody tr {
  transition: background-color 0.2s ease-in-out;
}

tbody tr:hover {
  background-color: rgba(71, 85, 105, 0.05);
}

/* Feature Expansion Animation */
tr.feature-expanded {
  animation: slideIn 0.3s ease-out;
}

/* QA Members Tags */
.qa-member-tag {
  animation: fadeIn 0.2s ease-out;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: rgba(59, 130, 246, 0.1);
  color: rgb(37, 99, 235);
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Attachment Grid */
.attachment-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}

@media (min-width: 640px) {
  .attachment-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}

@media (min-width: 768px) {
  .attachment-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
}

/* File Upload Drag and Drop */
.file-upload-area {
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.file-upload-area:hover {
  background-color: rgba(59, 130, 246, 0.05);
  border-color: rgb(59, 130, 246);
}

.file-upload-area.drag-over {
  background-color: rgba(59, 130, 246, 0.1);
  border-color: rgb(59, 130, 246);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .project-test-plan-form {
    padding: 1.5rem;
  }

  .section-header {
    font-size: 1.5rem;
  }

  table {
    font-size: 0.875rem;
  }

  .attachment-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
}

/* Dropdown styles */
.qa-dropdown {
  animation: slideIn 0.2s ease-out;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.qa-dropdown-item {
  transition: background-color 0.15s ease-in-out;
}

.qa-dropdown-item:hover {
  background-color: rgba(59, 130, 246, 0.05);
}

/* Module card styles */
.module-card {
  transition: all 0.2s ease-in-out;
}

.module-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

/* Feature list styles */
.feature-item {
  transition: all 0.2s ease-in-out;
  animation: slideIn 0.2s ease-out;
}

.feature-item:hover {
  background-color: rgba(59, 130, 246, 0.05);
}

/* Button hover effects */
button {
  transition: all 0.2s ease-in-out;
}

button:active {
  transform: scale(0.98);
}

/* Form validation styles */
.form-group-error {
  animation: slideIn 0.2s ease-out;
}

.error-message {
  color: rgb(220, 38, 38);
  font-size: 0.875rem;
  margin-top: 0.25rem;
  animation: slideIn 0.2s ease-out;
}

/* Success feedback */
.success-feedback {
  animation: fadeIn 0.3s ease-out;
}

/* Responsive typography */
@media (max-width: 640px) {
  h1 {
    font-size: 1.875rem;
  }

  h2 {
    font-size: 1.5rem;
  }

  h3 {
    font-size: 1.125rem;
  }

  .label {
    font-size: 0.875rem;
  }
}

/* Loading state */
.is-loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Print styles */
@media print {
  button,
  .action-buttons {
    display: none;
  }

  .form-group {
    page-break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/project-test-plan.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,eAAe;AACf;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA,8BAA8B;AAC9B;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Project Test Plan Styles */\n\n/* Animations */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Form Container Animations */\n.project-test-plan-form {\n  animation: slideIn 0.3s ease-out;\n}\n\n/* Section Headers */\n.project-test-plan-form h2 {\n  position: relative;\n  padding-bottom: 1rem;\n}\n\n/* Smooth transitions for form elements */\ninput[type=\"text\"],\ninput[type=\"date\"],\ntextarea,\nselect {\n  transition: all 0.2s ease-in-out;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"date\"]:focus,\ntextarea:focus,\nselect:focus {\n  transform: translateY(-1px);\n}\n\n/* Table Row Hover Effect */\ntbody tr {\n  transition: background-color 0.2s ease-in-out;\n}\n\ntbody tr:hover {\n  background-color: rgba(71, 85, 105, 0.05);\n}\n\n/* Feature Expansion Animation */\ntr.feature-expanded {\n  animation: slideIn 0.3s ease-out;\n}\n\n/* QA Members Tags */\n.qa-member-tag {\n  animation: fadeIn 0.2s ease-out;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background-color: rgba(59, 130, 246, 0.1);\n  color: rgb(37, 99, 235);\n  padding: 0.5rem 1rem;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n/* Attachment Grid */\n.attachment-grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n}\n\n@media (min-width: 640px) {\n  .attachment-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n}\n\n@media (min-width: 768px) {\n  .attachment-grid {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  }\n}\n\n/* File Upload Drag and Drop */\n.file-upload-area {\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n}\n\n.file-upload-area:hover {\n  background-color: rgba(59, 130, 246, 0.05);\n  border-color: rgb(59, 130, 246);\n}\n\n.file-upload-area.drag-over {\n  background-color: rgba(59, 130, 246, 0.1);\n  border-color: rgb(59, 130, 246);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .project-test-plan-form {\n    padding: 1.5rem;\n  }\n\n  .section-header {\n    font-size: 1.5rem;\n  }\n\n  table {\n    font-size: 0.875rem;\n  }\n\n  .attachment-grid {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  }\n}\n\n/* Dropdown styles */\n.qa-dropdown {\n  animation: slideIn 0.2s ease-out;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.qa-dropdown-item {\n  transition: background-color 0.15s ease-in-out;\n}\n\n.qa-dropdown-item:hover {\n  background-color: rgba(59, 130, 246, 0.05);\n}\n\n/* Module card styles */\n.module-card {\n  transition: all 0.2s ease-in-out;\n}\n\n.module-card:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n/* Feature list styles */\n.feature-item {\n  transition: all 0.2s ease-in-out;\n  animation: slideIn 0.2s ease-out;\n}\n\n.feature-item:hover {\n  background-color: rgba(59, 130, 246, 0.05);\n}\n\n/* Button hover effects */\nbutton {\n  transition: all 0.2s ease-in-out;\n}\n\nbutton:active {\n  transform: scale(0.98);\n}\n\n/* Form validation styles */\n.form-group-error {\n  animation: slideIn 0.2s ease-out;\n}\n\n.error-message {\n  color: rgb(220, 38, 38);\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n  animation: slideIn 0.2s ease-out;\n}\n\n/* Success feedback */\n.success-feedback {\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Responsive typography */\n@media (max-width: 640px) {\n  h1 {\n    font-size: 1.875rem;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n  }\n\n  h3 {\n    font-size: 1.125rem;\n  }\n\n  .label {\n    font-size: 0.875rem;\n  }\n}\n\n/* Loading state */\n.is-loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Print styles */\n@media print {\n  button,\n  .action-buttons {\n    display: none;\n  }\n\n  .form-group {\n    page-break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
